import React, { useContext } from 'react'
import "./certify.css";

import { UserContext } from '../../App';
import chegg from "../../assets/chegg.jpg"
import Nit from "../../assets/naresh-it.jpg";
import codtech from "../../assets/Codtech.jpg";



function Certify() {
    const {theme,setTheme}=useContext(UserContext);
  return (
    <>

    <div className='cert-main' style={{textAlign:"center"}}>
     <h2 className={theme==0?"name-light":"name-dark"}>Certifications</h2>
     <div className='cert' style={{display:"flex",flexWrap:"wrap",justifyContent:"space-around",gap:"1rem"}}>
        <div className='cert-item'>
            <a href="http://localhost:3000/static/media/Prodigy-lor.b7014f92eb9661ac4789.jpg" target='_blank'><img style={{borderRadius:"1rem"}} src={codtech} alt="codtech" width="200px"/></a>
        </div>
        <div className='cert-item'>
            <a href="http://localhost:3000/static/media/chegg.b88134126d0cf3158866.jpg" target='_blank' >            
            <img style={{borderRadius:"1rem"}} src={chegg} alt="chegg" width="200px"/>
            </a>

        </div>
        <div className='cert-item'>
            <a href="http://localhost:3000/static/media/naresh-it.459167cafcad705eed8c.jpg" target='_blank'>
            <img style={{borderRadius:"1rem"}} src={Nit} alt="naresh it" width="200px"/>
            </a>
        </div>
     </div>
    </div>
    </>
  )
}

export default Certify
